import React from 'react';
import { useAuth } from '../../hooks/auth-provider';

const CanAccess = ({ permission, permissions, role, roles, rolesExclude, requireAll = false, module, action = 'view', fallback = null, children }) => {
    const { hasPermission, hasAnyPermission, hasAllPermissions, hasRole, hasAnyRole, hasAllRoles, canAccess, canPerform } = useAuth();

    // Check single permission
    if (permission) {
        if (!hasPermission(permission)) {
            return fallback;
        }
    }

    // Check multiple permissions
    if (permissions && Array.isArray(permissions)) {
        const hasAccess = requireAll ? hasAllPermissions(permissions) : hasAnyPermission(permissions);

        if (!hasAccess) {
            return fallback;
        }
    }

    // Check single role
    if (role) {
        if (!hasRole(role)) {
            return fallback;
        }
    }

    // Check multiple roles
    if (roles && Array.isArray(roles)) {
        const hasAccess = requireAll ? hasAllRoles(roles) : hasAnyRole(roles);

        if (!hasAccess) {
            return fallback;
        }
    }

    // Check module access
    if (module) {
        const hasAccess = action === 'view' ? canAccess(module) : canPerform(module, action);

        if (!hasAccess) {
            return fallback;
        }
    }

    if (rolesExclude && Array.isArray(rolesExclude) && rolesExclude.length > 0) {
        if (hasAnyRole(rolesExclude)) {
            return fallback;
        }
    }

    // If all checks pass, render children
    return <>{children}</>;
};

export default CanAccess;
